// extracted by mini-css-extract-plugin
export var container = "_dx-0";
export var popoverContent = "_dx-1";
export var tosLink = "_dx-2";